import {HttpInterceptorFn,HttpErrorResponse} from '@angular/common/http';
import {inject,PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {logEvent} from 'firebase/analytics';
import {FIREBASE_ANALYTICS} from './firebase/firebase.tokens';
import {ConsentService} from './consent/consent.service';
import {catchError,throwError} from 'rxjs';

export const httpErrorInterceptor:HttpInterceptorFn=(req,next)=>{
	const platformId=inject(PLATFORM_ID);
	const resolveAnalytics=inject(FIREBASE_ANALYTICS);
	const consent=inject(ConsentService);

	return next(req).pipe(
		catchError((error:unknown)=>{
			if(isPlatformBrowser(platformId)&&consent.analytics()&&error instanceof HttpErrorResponse){
				try{
					const analytics=resolveAnalytics();
					if(!analytics) return throwError(()=>error);
					logEvent(analytics,'http_error',{
						status:error.status,
						url:error.url?.substring(0,200),
						message:error.message?.substring(0,100)
					});
				}catch{
					// Avoid errors from analytics logging
				}
			}
			return throwError(()=>error);
		})
	);
};
